import React from "react";
import Typography from "@material-ui/core/Typography";
import Swipeable from "../../../Fronts/Main/Swipeable";
import Grid from "@material-ui/core/Grid";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Divider from "@material-ui/core/Divider";
import { Button, colors, TextField } from "@material-ui/core";
import CheckboxItem, { useStylesAcc } from "./CheckBoxComponent";
import DiscountPermissions from "./discount-permissions";
import { billPrintType, cashirPrintType } from "../PrintCasher";
import { GetItemFromOptions } from "../../../services/global-services";
import { Autocomplete } from "@material-ui/lab";
import { useTranslation } from "react-i18next";
const formData = [
  { name: "Automatic_Insert", label: "automatic-entry", visible: true },

  {
    name: "UpdatePurchDate",
    label: "allow-edit-purchase-invoice-date",
    visible: true,
  },
  {
    name: "UpdatePurchPrice",
    label: "allow-edit-purchase-price",
    visible: true,
  },
  {
    name: "purchVatUpdate",
    label: "allow-edit-tax-on-purchase",
    visible: true,
  },
  {
    name: "use_price_without_vat",
    label: "use-price-excluding-tax-purchase-invoice",
    visible: true,
  },
  {
    name: "Purch_than_Less_Purch_Item",
    label: "allow-purchase-below-item-purchase-price",
    visible: true,
  },
  {
    name: "SaleInMinus",
    label: "allow-purchase-return-without-stock-quantity",
    visible: true,
  },
  {
    name: "Cust_PurchPrice",
    label: "approve-last-supplier-purchase-price",
    visible: false,
  },
  {
    name: "Hide_Purch_Bill_Price",
    label: "hide-sale-price",
    visible: true,
  },
  {
    name: "Purch_out_goods",
    label: "print-goods-exit-permit-purchase-return",
    visible: true,
  },
 
  { 
    name: "allow_discount", 
    label: "allow-discount", 
    visible: true 
  },
  // {
  //   name: "inv_post_unlock",
  //   label: "allow-edit-delete-posted-invoice",
  //   visible: true,
  // },
  {
    name: "IS_Delete",
    label: "allow-delete-invoice-after-posting",
    visible: true,
  },
  {
    name: "IS_Update",
    label: "allow-edit-invoice-after-posting",
    visible: true,
  },
  {
    name: "NoRepeatItem",
    label: "disable-item-grouping",
    visible: true,
  },
  {
    name: "Cust_SalePrice",
    label: "approve-last-supplier-purchase-price-for-customer",
    visible: true,
  },
  {
    name: "return_same_invoice_date",
    label: "return-invoice-same-purchase-date",
    visible: true,
  },
  {
    name: "allow_return_Without_bill",
    label: "allow-return-without-invoice",
    visible: true,
  },
  {
    name: "use_barcode_reader",
    label: "use-barcode-reader",
    visible: true,
  },
];

export default function PurchPermissions(props) {
  const { onChange, object, update, sub } = props;
  const { t } = useTranslation(["forms"]);

  const classes = useStylesAcc();
  const valuelargePrinter = GetItemFromOptions(parseInt(object?.largePrinter??1) ?? 1, billPrintType);
  const valuesmallPrinter = GetItemFromOptions(parseInt(object?.smallPrinter??1) ?? 1, cashirPrintType);


  return (
    <div className={classes.root}>
      <Accordion expanded={true}>
        {/* <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          style={{ background: "#d9dcf078" }}
        >
          <Typography className={classes.heading}>{t("purchase-settings")}</Typography>
        </AccordionSummary> */}


        <AccordionDetails >
          <Grid item container spacing={1}>
            {formData
              ?.filter((d) => d.visible)
              ?.map((item) => {
                // console.log(object);
                return (
                  <Grid xs={6}>
                    <CheckboxItem
                      value={object[item.name] ?? null}
                      name={item.name}
                      label={t(item.label)}
                      onChange={onChange}
                    />
                  </Grid>
                );
              })}
          </Grid>
        </AccordionDetails>
        <Grid container lg={12} md={12} sm={12} xs={12} style={{ padding: 5 }} spacing={1}>
          <Grid item xs={6} lg={4} md={6} sm={6}>
            <Autocomplete
              value={valuelargePrinter}
              onChange={(event, newValue) => {
                onChange(null, {
                  name: "largePrinter",
                  value: newValue?.id,
                });
              }}
              id="apply_discount"
              size="small"
              options={billPrintType}
              getOptionLabel={(option) =>
                typeof option === "string" ? option : t(option.name)
              }
              style={{}}
              disableClearable
              renderInput={(params) => (
                <TextField
                  {...params}
                  InputLabelProps={{ shrink: true }}
                  label={t("a4-print-template")}
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={6} lg={4} md={6} sm={6}>
            <Autocomplete
              value={valuesmallPrinter}
              onChange={(event, newValue) => {
                onChange(null, {
                  name: "smallPrinter",
                  value: newValue?.id,
                });
              }}
              id="apply_discount"
              size="small"
              options={cashirPrintType}
              getOptionLabel={(option) =>
                typeof option === "string" ? option : t(option.name)
              }
              style={{}}
              disableClearable
              renderInput={(params) => (
                <TextField
                  {...params}
                  InputLabelProps={{ shrink: true }}
                  label={t("cashier-print-template")}
                  variant="outlined"
                />
              )}
            />
          </Grid>
        </Grid>

        <AccordionDetails>
          {" "}
          <Typography>{t("purchase-discount-settings")}  
          
            </Typography>{" "}    
             
                   
        </AccordionDetails>

        <AccordionDetails style={{backgroundColor:colors.grey[50]}}>
          { object?.allow_discount ? <DiscountPermissions {...props} />: 
          <Typography variant="h5" style={{textAlign:"center"}}> 
          {/* <br />   */}
          {/* {"\n this settings don't work if past discount allowed attribute doesn't enables"} */}
          {"\n "}{t("enable-discount-first-warning")}

            </Typography> }
        </AccordionDetails>
        <Divider className={classes.divider} />
        <AccordionDetails className={classes.subTitle}>
          {" "}
          <Typography>
            {" "}
            <Button
              variant="contained"
              color="secondary"
              size="large"
              disabled={props.submitting}
              onClick={update}
            >
              {t("save-changes")}
            </Button>
          </Typography>{" "}
        </AccordionDetails>
      </Accordion>
      <Swipeable />
    </div>
  );
}
